import { PRODUCT_MUTATIONS } from './mutationTypes';

/**
 * Helper functions for working with mutations in components
 * These functions provide a cleaner way to work with constant mutations
 */

/**
 * Creates mutation mapping object for mapMutations
 * @param {Array} mutationNames - Array of mutation names from PRODUCT_MUTATIONS
 * @returns {Object} - Object for mapMutations
 */
export const createMutationMap = (mutationNames) => {
  return mutationNames.reduce((acc, name) => {
    // Convert mutation name to camelCase for method name (e.g. SET_LOADING -> setLoading)
    const methodName = name
      .toLowerCase()
      .replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());

    // Map it to the namespaced mutation
    acc[methodName] = `product/${PRODUCT_MUTATIONS[name]}`;

    return acc;
  }, {});
};

/**
 * Creates a Vuex mutation commit function that uses constant
 * @param {Function} commit - Vuex commit function
 * @param {String} type - Mutation name from PRODUCT_MUTATIONS
 * @returns {Function} - Function that commits the mutation
 */
export const createMutationCommitter = (commit, type) => {
  return (payload) => commit(`product/${PRODUCT_MUTATIONS[type]}`, payload);
};

/**
 * Creates a full set of mutation committers for a component
 * @param {Function} commit - Vuex commit function
 * @returns {Object} - Object containing commit functions
 */
export const createMutationCommitters = (commit) => {
  return Object.keys(PRODUCT_MUTATIONS).reduce((acc, key) => {
    // Convert mutation name to camelCase for method name
    const methodName = key
      .toLowerCase()
      .replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());

    // Create the commit function
    acc[methodName] = (payload) =>
      commit(`product/${PRODUCT_MUTATIONS[key]}`, payload);

    return acc;
  }, {});
};

/**
 * Common mutations used in AddProduct component
 */
export const COMMON_MUTATIONS = [
  'SET_SELECTED_CATEGORY_ID',
  'SET_SELECTED_BRAND_ID',
  'SET_SELECTED_PARENT_ID',
  'SET_FILTERED_CATEGORIES',
  'SET_FILTERED_BRANDS',
];
